import React from "react";

export default function LegalPage({ title, subtitle, children, testId }) {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-16 lg:py-20" data-testid={testId}>
      <p className="label-xs opacity-60">{subtitle}</p>
      <h1 className="mt-3 text-5xl lg:text-6xl font-serif tracking-tighter">{title}</h1>
      <div className="mt-10 prose-legal">
        {children}
      </div>
      <style>{`
        .prose-legal h2 { font-family: 'Cormorant Garamond', serif; font-size: 1.75rem; letter-spacing: -0.01em; margin-top: 2.5rem; margin-bottom: 0.75rem; }
        .prose-legal h3 { font-family: 'Cormorant Garamond', serif; font-size: 1.25rem; margin-top: 1.5rem; margin-bottom: 0.5rem; }
        .prose-legal p, .prose-legal li { line-height: 1.75; opacity: 0.85; margin-bottom: 0.75rem; }
        .prose-legal ul { list-style: disc; padding-left: 1.25rem; }
        .prose-legal a { text-decoration: underline; }
      `}</style>
    </div>
  );
}
